import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.9.6c-.1-.2-.3-.4-.5-.5-.1-.1-.3-.1-.4-.1H1C.4 0 0 .4 0 1s.4 1 1 1h7.6L.3 10.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L10 3.4V11c0 .6.4 1 1 1s1-.4 1-1V1c0-.1 0-.3-.1-.4"
    }, null, -1)
  ]))]))
}
export default { render: render }